import React, { useEffect, useState } from 'react';
import { getStatoServer, riprovaOra } from '../../services/serverRetry';

const ETICHETTA = {
  middleware: 'Server non raggiungibile',
  search: 'Servizio di ricerca non raggiungibile',
};

/**
 * ServerStatusBanner - Barra globale "Server non raggiungibile" con conto alla rovescia.
 * Ascolta l'evento `server:status` emesso da services/serverRetry.js; una riga per ogni server
 * offline. Di default fissa sotto l'header, sotto le finestre modali (z-50); `className` permette
 * un posizionamento diverso (dashboard-anutel la monta in flusso, in cima alla pagina).
 */
const CLASSE_FISSA = 'fixed left-0 right-0 top-[97px] z-[35] px-4 sm:px-6 space-y-1 pointer-events-none';

export default function ServerStatusBanner({ className = CLASSE_FISSA }) {
  const [stato, setStato] = useState(getStatoServer);

  useEffect(() => {
    const onStatus = (e) => {
      const { server, offline, controllando, secondiAlProssimoTentativo } = e.detail;
      setStato((prev) => ({ ...prev, [server]: { offline, controllando, secondiAlProssimoTentativo } }));
    };
    window.addEventListener('server:status', onStatus);
    setStato(getStatoServer());
    return () => window.removeEventListener('server:status', onStatus);
  }, []);

  const offline = Object.entries(stato).filter(([, s]) => s.offline);
  if (offline.length === 0) return null;

  return (
    <div className={className}>
      {offline.map(([server, s]) => (
        <div
          key={server}
          role="alert"
          className="pointer-events-auto flex items-center gap-3 bg-amber-50 border border-amber-300 text-amber-900 rounded-lg px-4 py-2 text-sm shadow"
        >
          <svg className="w-5 h-5 text-amber-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
          </svg>
          <span className="flex-1">
            {s.controllando
              ? 'Tentativo di connessione in corso…'
              : `${ETICHETTA[server]} — nuovo tentativo fra ${s.secondiAlProssimoTentativo} secondi`}
          </span>
          <button
            type="button"
            onClick={() => riprovaOra(server)}
            disabled={s.controllando}
            className="px-3 py-1 text-xs font-semibold rounded-md border border-amber-400 bg-white hover:bg-amber-100 disabled:opacity-50 transition-colors flex-shrink-0"
          >
            Riprova ora
          </button>
        </div>
      ))}
    </div>
  );
}
